import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    informe: [],
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_INFORME = 'GET_ALL_INFORME'
const GET_INFORME_BY_ID = 'GETINFORME_BY_ID'
const GET_INFORME_BY_ID_INSTALACION = 'GET_INFORME_BY_ID_INSTALACION'
const GET_INFORME_BY_ID_SOLICITUD = 'GET_INFORME_BY_ID_SOLICITUD'
const POST_INFORME = 'POST_INFORME'
const UPDATE_INFORME = 'UPDATE_INFORME'
const DELETE_INFORME = 'DELETE_INFORME'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllInformes = createAsyncThunk(
    GET_ALL_INFORME,
    async () => {
        try {
            const fullUrl = host + `Fi25InformeCumplimientoNom/obtenerInformesNom`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las Caratulas: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getInformeById = createAsyncThunk(
    GET_INFORME_BY_ID,
    async (idInforme) => {
        try {
            const fullUrl = host + `Fi25InformeCumplimientoNom/obtenerInformeNomById/${idInforme}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getInformeByIdInstalacion = createAsyncThunk(
    GET_INFORME_BY_ID_INSTALACION,
    async (idInstalacion) => {
        try {
            const fullUrl = host + `Fi25InformeCumplimientoNom/obtenerInformeNomByIdInstalacion/${idInstalacion}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getInformeByIdSolicitud = createAsyncThunk(
    GET_INFORME_BY_ID_SOLICITUD,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `Fi25InformeCumplimientoNom/obtenerInformeNomByIdSolicitud/${idSolicitud}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertInforme = createAsyncThunk(
    POST_INFORME,
    async (data) => {
        try {
            const fullUrl = host + `Fi25InformeCumplimientoNom/agregarInformeNom`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateInforme = createAsyncThunk(
    UPDATE_INFORME,
    async (data) => {
        try {
            const fullUrl = host + `Fi25InformeCumplimientoNom/actualizarInformeNom`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteInforme = createAsyncThunk(
    DELETE_INFORME,
    async (idInforme) => {
        try {
            const fullUrl = host + `Fi25InformeCumplimientoNom/eliminarInformeNom/${idInforme}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosInformeSlice = createSlice({

    name: 'metodosInformeSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllInformes.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.informe = payload.data.data
        
        },
        [getInformeById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.informe = payload.data.data
        },
        [getInformeByIdInstalacion.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.informe = payload.data.data
        },
        [getInformeByIdSolicitud.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.informe = payload.data.data
        },
        [insertInforme.fulfilled]: (state, { payload }) => {
        },
        
        [updateInforme.fulfilled]: (state, { payload }) => {
        
        },
        [deleteInforme.fulfilled]: (state, { payload }) => {
        
        },

    },

})


export const { } = metodosInformeSlice.actions
export const InformeReducer = metodosInformeSlice.reducer